// src/components/Banner.js
import React from 'react'

const Banner = () => {
  return (
    <div className='bg-blue-600 text-white py-4 px-6 flex items-center justify-between sm:hidden font-nunito'>
      <div className='flex items-center'>
        <div>
          <h2 className='text-lg font-semibold'>Get Our Mobile App!</h2>
          <p className='text-xs'>Available on iOS and Android.</p>
        </div>
      </div>
      <div className='flex gap-2 flex-wrap justify-end text-sm'>
        <a
          href='https://apps.apple.com/in/app/scopex/id6456889025'
          className='bg-white text-blue-600 px-4 py-2 rounded-full shadow-md hover:bg-gray-100 transition'
        >
          App Store
        </a>
        <a
          href='https://play.google.com/store/apps/details?id=com.scopex.scopexmobile'
          className='bg-white text-blue-600 px-4 py-2 rounded-full shadow-md hover:bg-gray-100 transition'
        >
          Google Play
        </a>
      </div>
    </div>
  )
}

export default Banner
